export class GetConnectionCodeAction {
    constructor() {
        this.name = 'GetConnectionCode';
        this.isDeviceAction = false;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiR2V0Q29ubmVjdGlvbkNvZGVBY3Rpb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvbGliL21vZGVscy9hY3Rpb25zL0dldENvbm5lY3Rpb25Db2RlQWN0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU1BLE1BQU0sT0FBTyx1QkFBdUI7SUFBcEM7UUFDa0IsU0FBSSxHQUFHLG1CQUFtQixDQUFDO1FBQzNCLG1CQUFjLEdBQUcsS0FBSyxDQUFDO0lBQ3pDLENBQUM7Q0FBQSJ9